import { Component, ViewChild } from "@angular/core";
import { AuthService } from "../../services/auth.service";
import { environment } from "src/environments/environment";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { scrollIntoView } from 'src/app/main/util/dom.util';

@Component({
	selector: "app-embroidered",
	templateUrl: "./embroidered-workwear-mackay.component.html",
	styleUrls: [],
})
export class EmbroideredMackyComponent {
	public apiURL = environment.endpoint;
	constructor(private router: Router, private route: ActivatedRoute) {
		this.navigateAbove();
		this.route.fragment.subscribe((fragment) => {
			scrollIntoView(fragment);
		});

		const currentFragment = this.route.snapshot.fragment;
		scrollIntoView(currentFragment);

		this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				document.body.style.overflow = 'auto';
				document.documentElement.style.overflow = 'auto';
			}
		});
	}

	navigateAbove() {
		window.scroll(0, 0);
	}

	handleClick() {
		window.dispatchEvent(
			new CustomEvent('heyflow-modal-element:open', {
				detail: { modalId: 'ce4s7ECeNPx0m0hEQ5TmE' },
			})
		);
	}
}
